import React, { useState } from 'react';
import './AuthPopup.css';

const AuthPopup = ({ isOpen, onClose, onSignIn }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;

    setLoading(true);
    setMessage('');

    const result = await onSignIn(email.trim());
    
    if (result.success) {
      setIsSuccess(true);
      setMessage('Check your email for a magic link to sign in!');
      setEmail('');
    } else {
      setIsSuccess(false);
      setMessage(result.error || 'Something went wrong. Please try again.');
    }
    
    setLoading(false);
  };

  const handleClose = () => {
    setEmail('');
    setMessage('');
    setIsSuccess(false);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="auth-popup-overlay" onClick={handleClose}>
      <div className="auth-popup" onClick={(e) => e.stopPropagation()}>
        <button className="auth-popup-close" onClick={handleClose}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
        
        <div className="auth-popup-content">
          <h2>Join the Discussion</h2>
          <p>Sign in or create an account to comment on recommendations</p>
          
          {message && (
            <div className={`auth-message ${isSuccess ? 'success' : 'error'}`}>
              {message}
            </div>
          )}
          
          {!isSuccess && (
            <form onSubmit={handleSubmit} className="auth-form">
              <div className="auth-input-group">
                <label htmlFor="email">Email Address</label>
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  required
                  disabled={loading}
                />
              </div>
              
              <button 
                type="submit" 
                className="auth-submit-btn"
                disabled={loading || !email.trim()}
              >
                {loading ? 'Sending...' : 'Send Magic Link'}
              </button>
            </form>
          )}
          
          <div className="auth-footer">
            <p>We'll send you a secure link to sign in instantly - no password needed!</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthPopup;
